import React from "react";


import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmazonPay,
} from "react-icons/fa";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-top container py-5">
        <div className="row g-4">
          {/* Brand / About */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand">
              <h4 className="mb-2">GOLDEN HIDES</h4>
              <p className="muted mb-3">
                Step into style. Premium leather, curated trends and effortless
                shopping — all in one place.
              </p>

              <div className="d-flex gap-2 mb-2">
                <a
                  href="https://www.facebook.com/profile.php?id=61585302212661&rdid=kIyx7o8UpRuok0kq&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BoARdaRgo%2F%3Futm_source%3Dig%26utm_medium%3Dsocial%26utm_content%3Dlink_in_bio#"
                  aria-label="Facebook"
                  className="social-link"
                  title="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/golden_hides/"
                  aria-label="Instagram"
                  className="social-link"
                  title="Instagram"
                >
                  <FaInstagram />
                </a>
                {/*<a
                  href="#"
                  aria-label="Twitter"
                  className="social-link"
                  title="Twitter"
                >
                  <FaTwitter />
                </a>
                <a
                  href="#"
                  aria-label="LinkedIn"
                  className="social-link"
                  title="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>*/}
              </div>

              <div className="payment-logos d-flex align-items-center gap-2 mt-3">
                <FaCcVisa className="payment-icon" />
                <FaCcMastercard className="payment-icon" />
                <FaCcAmazonPay className="payment-icon" />
                {/* Replace above with actual brand images if you have them */}
              </div>
            </div>
          </div>

          {/* Quick links (two columns) 
          <div className="col-lg-2 col-md-6">
            <h6 className="footer-heading">Shop</h6>
            <ul className="footer-links">
              <li>
                <Link to="/categories">Categories</Link>
              </li>
              <li>
                <Link to="/products">All Products</Link>
              </li>
              <li>
                <Link to="/offers">Offers</Link>
              </li>
              <li>
                <Link to="/new-arrivals">New Arrivals</Link>
              </li>
            </ul>
          </div>*/}

          {/*<div className="col-lg-2 col-md-6">
            <h6 className="footer-heading">Support</h6>
            <ul className="footer-links">
              <li>
                <Link to="/returns">Returns</Link>
              </li>
              <li>
                <Link to="/shipping"> Shipping</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy</Link>
              </li>
              <li>
                <Link to="/support">Help Center</Link>
              </li>
            </ul>
          </div>*/}

          <div className="col-lg-4 col-md-6">
            <h6 className="footer-heading">Subscribe & Save</h6>
            <p className="muted small mb-3">
              Get early access to sales, new arrivals and styling tips.
            </p>

            <form
              className="subscribe-form d-flex gap-2"
              onSubmit={(e) => {
                e.preventDefault();
                // optionally: implement subscription call
                alert("Subscribed successfully!");
              }}
            >
              <input
                type="email"
                className="form-control subscribe-input"
                placeholder="Your email address"
                aria-label="Email address"
                required
              />
              <button className="btn btn-primary subscribe-btn" type="submit">
                Subscribe
              </button>
            </form>

            <div className="mt-3 small muted">
              <strong>Need help?</strong> &nbsp;
              <Link to="/contact" className="text-link">
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom py-3">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="small muted mb-2 mb-md-0">
            © {year} Golden hides. All rights reserved.
          </div>

          <div className="d-flex align-items-center gap-3">
            <Link to="/terms" className="small muted text-link">
              {/*Terms*/}
            </Link>
            <Link to="/privacy" className="small muted text-link">
              {/*Privacy*/}
            </Link>
            <Link to="/sitemap" className="small muted text-link">
              {/*Sitemap*/}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
